<template>
  <div class="text-center">
    <v-dialog
      v-model="loadDialog"
      persistent
      max-width="800"
      eager
    >
      <template>
          <v-spacer></v-spacer>
          <loading-media-bar
            :onLoading="loading"
            :progressPercent="progressPercent"
          />
      </template>
      <v-card style="position: relative">
        <v-container>
          <v-card-text>
            <h3>Selecciona o carga un video:</h3>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center mb-4" >
              <v-btn
                @click="onPickFile()"
                :color="mainColor"
                outlined
              > Cargar Video
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="video/*"
                @change="onFilePicked">
            </v-col>
            <v-btn
              @click="LoadVideoDialogProps.loadDialog=false"
              fixed
              right
              style="top: 15px;"
              light
              fab
              small
            >X</v-btn>
          </v-card-actions>

          <template>
            <v-row style="position: relative">
              <v-col cols="12" sm="8" offset-sm="2">
                <v-card flat>
                  <v-container fluid>
                    <v-row  >
                      <v-col class="d-flex pr-1 pl-1 pb-2"
                        v-for="(video, index) in loadMedia"
                        :key="index"
                        cols="4"

                      >
                        <v-card hover light>
                          <video
                            @click="sendData(video.url, video.thumbnail)"
                            :src="video.url"
                            class="grey darken-2 pa-0"
                            width="100%"
                            height="150"
                            preload="metadata"
                          ></video>
                          <!-- <v-img
                            @click="sendData(video.url, video.thumbnail)"
                            :src="video.thumbnail"
                            aspect-ratio="1"
                            class="grey darken-2"
                            contain
                            eager
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img> -->
                          <v-card-text>
                            <div class="text-center">{{video.name}}</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-console */
import * as util from '../../util'
import * as constants from '../../../constants.json'

export default {
  props: ['LoadVideoDialogProps', 'companyId'],
  data () {
    return {
      loading: false,
      mainColor: constants.MAINCOLOR,
      progressPercent: ''
    }
  },
  computed: {
    loadDialog () {
      return this.LoadVideoDialogProps.loadDialog
    },

    loadMedia () {
      const loadVideos = this.$store.getters.getMedia
      const videos = []
      loadVideos.forEach(loadVideo => {
        if (loadVideo.type === 'video') {
          videos.push({
            name: loadVideo.name,
            url: loadVideo.url
          })
        }
      })
      return videos
    },

    onLoading () {
      return this.$store.getters.getLoading
    }
  },

  methods: {
    /**
     * Send Data to main component
     */
    sendData (videoUrl, videoThumbnail) {
      this.LoadVideoDialogProps.videoUrl = videoUrl
      // Closing Dialog window
      this.LoadVideoDialogProps.loadDialog = false
    },

    /**
     * Selecting input element when button is pressed to upload a file
     */
    onPickFile () {
      this.$refs.fileInput.click()
    },

    /**
     * Uploading image or video files and generating the thumbnail
     */
    async onFilePicked (event) {
      console.log('Loading video file')
      const file = event.target.files[0]
      let fileName = file.name
      if (fileName.lastIndexOf('.') <= 0) {
        return alert('Por favor ingresa un archivo valido!')
      }
      const fileReader = new FileReader()

      fileReader.readAsArrayBuffer(file)
      console.log('readyState: ', fileReader.readyState)
      this.saveVideo(file)

      // Closing Dialog window
      this.LoadVideoDialogProps.loadDialog = false
    },

    async saveVideo (videoFile) {
      this.loading = true
      console.log('videoFile:', videoFile)

      // Saving the video file in our data
      console.log('Storing the image file')

      const data = await util.storeMediaOnFirebase(videoFile, this.companyId, (data) => {
        let percent = (data.bytesTransferred / data.totalBytes) * 100
        this.progressPercent = percent
        console.log('progressPercent: ', this.progressPercent)
      })

      await this.$store.dispatch('actionAddMedia', {
        companyId: this.companyId,
        fullName: data.fullName,
        url: data.fileUrl,
        type: data.type
      })

      this.LoadVideoDialogProps.videoUrl = data.fileUrl
      this.loading = false
    }
  }
}
</script>
